import { useLingui } from '@lingui/react';
import { Carousel } from '@mantine/carousel';
import { Box, Card, Group, Stack } from '@mantine/core';
import { useState } from 'react';
import { CardTitle } from '../Shares/CardTitle';
import { CarouselControl } from '../Shares/CarouselControl';
import { ThemeCardItem } from './ThemeCardItem';
import { themes } from './casino';
export const CasinoThemeCard: React.FC = () => {
  const [active, setActive] = useState(0);
  const {
    i18n
  } = useLingui();
  const handleNext = () => {
    setActive(prev => (prev + 1) % themes.length);
  };
  const handlePrev = () => {
    setActive(prev => (prev - 1 + themes.length) % themes.length);
  };
  return <Card bg="var(--navbar-bg-color)" my={12} radius="sm">
      <Stack>
        <Group justify="space-between" wrap="nowrap" gap={4}>
          <Box>
            <CardTitle firstText={i18n._('Themes')} isFirstGradient colorFrom="#B9C7D4" colorTo="#B9C7D4" iconUrl="/assets/title-icons/10.png" mt={6} />
          </Box>
          <CarouselControl link="#" handleNext={handleNext} handlePrev={handlePrev} />
        </Group>

        <Box pos="relative" style={{
        maskImage: 'linear-gradient(275deg, rgba(255,255,255,0) 0%, rgb(34 38 43) 15%)'
      }}>
          <Carousel align="start" h="100%" slideSize={{
          base: '20%',
          sm: '20%',
          md: '25%',
          xl: '20%'
        }} slideGap="md" loop withControls={false} initialSlide={active} onSlideChange={setActive}>
            {themes.map(item => <Carousel.Slide key={item.text}>
                <ThemeCardItem imgUrl={item.imgUrl} text={item.text} />
              </Carousel.Slide>)}
          </Carousel>
        </Box>
      </Stack>
    </Card>;
};